import { keycloak } from "../auth";
import { getEnv } from "../services/api";


export async function hasRole(profileOverride = null, roleOverride = null) {
    try {
        const env = await getEnv('ENV');

        const profile = profileOverride || (env === 'prod' ? 'NA_PALMA_ADMIN' : 'ADMINISTRADOR');
        const RESOURCE_ACCESS_CLIENT_ID = roleOverride || (env === 'prod' ? 'na-palma' : 'na-palma-web');

        if (keycloak?.hasResourceRole) {
            return keycloak.hasResourceRole(profile, RESOURCE_ACCESS_CLIENT_ID);
        }
        return false;
    } catch (error) {
        console.error('Erro ao verificar as permissões ou ambiente:', error);
        return false;
    }
}

export async function hasAdminRole() {
    if (keycloak && !keycloak.authenticated) {
        return false;
    }
    return await hasRole();
}

export async function hasGestorSSERole() {
    if (keycloak && !keycloak.authenticated) {
        return false;
    }
    const roleGestorSSE = 'GESTOR_SSE';

    return await hasRole(roleGestorSSE)
        || await hasRole(roleGestorSSE, 'na-palma')
        || await hasRole(roleGestorSSE, 'na-palma-backend')
        || await hasRole(roleGestorSSE, 'na-palma-web');
}


